export const NETWORKS = [
  {
    rpcUrl:
      "https://rpc.ankr.com/base/1b49ccfb464d3a36778d62cd26f29d2da87e099d5ed6229c15bc1627cee80453",
    contractAddress: "0x243048D7C2229029E46eA800C0a37f751B7a6805",
  },
  {
    rpcUrl:
      "https://rpc.ankr.com/eth/be9a41869c1ad6c0d6318698e56698043f082c055680e5eb4f9a163a68f0449e",
    contractAddress: "0xFACA9A111664Bc8A912bA704C93b19F38a2d3fFB",
  },
  {
    rpcUrl:
      "https://rpc.ankr.com/bsc/be9a41869c1ad6c0d6318698e56698043f082c055680e5eb4f9a163a68f0449e",
    contractAddress: "0x0ac016Cd0F4f5F481A95fa09279a7b4F2713B264",
  },
];

export const BASE_URL = "https://babyu.tech/";

export const aggregatorV3ABI = [
  {
    inputs: [],
    name: "latestRoundData",
    outputs: [
      { internalType: "uint80", name: "roundId", type: "uint80" },
      { internalType: "int256", name: "answer", type: "int256" },
      { internalType: "uint256", name: "startedAt", type: "uint256" },
      { internalType: "uint256", name: "updatedAt", type: "uint256" },
      { internalType: "uint80", name: "answeredInRound", type: "uint80" },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export const feeds = {
  ethereum: {
    rpc: "https://rpc.ankr.com/eth/1b49ccfb464d3a36778d62cd26f29d2da87e099d5ed6229c15bc1627cee80453",
    tokens: {
      ETH: "0x5f4ec3df9cbd43714fe2740f5e3616155c5b8419",
    },
  },
  bsc: {
    rpc: "https://rpc.ankr.com/bsc/1b49ccfb464d3a36778d62cd26f29d2da87e099d5ed6229c15bc1627cee80453",
    tokens: {
      BNB: "0x0567f2323251f0aab15c8dfb1967e4e8a7d42aee",
    },
  },
  polygon: {
    rpc: "https://rpc.ankr.com/polygon/1b49ccfb464d3a36778d62cd26f29d2da87e099d5ed6229c15bc1627cee80453",
    tokens: {
      MATIC: "0xab594600376ec9fd91f8e885dadf0ce036862de0",
    },
  },
};
